import type { AuftragsStatus, AuftragsTyp } from '@awf/shared';
import { aktuellerSchritt, gruppeVon, STATUS_TEXT } from '../runs/status.js';
import stile from './status-chip.module.css';

// Mit Typ nennt der Chip eines laufenden Auftrags den Schritt aus dem Typ-Register (bei einer
// Analyse "Analyse" statt "Recherche"). Wartende, fertige, fehlerhafte und ueberarbeitete
// Status behalten ihren Statustext.
export function statusText(status: AuftragsStatus, typ?: AuftragsTyp): string {
  return typ !== undefined && gruppeVon(status) === 'laeuft' && status !== 'in_ueberarbeitung'
    ? (aktuellerSchritt(typ, status)?.titel ?? STATUS_TEXT[status])
    : STATUS_TEXT[status];
}

export function StatusChip({ status, typ }: { status: AuftragsStatus; typ?: AuftragsTyp }) {
  const gruppe = gruppeVon(status);
  const text = statusText(status, typ);
  return (
    <span className={`eds-chip ${stile.chip} ${stile[gruppe]}`}>
      <span className={stile.punkt} aria-hidden="true" />
      {text}
    </span>
  );
}
